/* MATERIALS */
export const GET_MATERIALS = "GET_MATERIALS"
export const GET_MATERIALS_SUCCESS = "GET_MATERIALS_SUCCESS"
export const GET_MATERIALS_FAIL = "GET_MATERIALS_FAIL"
export const DELETE_MATERIAL = "DELETE_MATERIAL"
export const ADD_MATERIAL = "ADD_MATERIAL"
export const EDIT_MATERIAL = "EDIT_MATERIAL"
